import React from 'react';
import { ActionPortalType } from '../../../types/actionPortal.type';
import { useOpenOtpModal } from '../../../stores/otpModal.store';
import actionBoxLang from '../../../data/lang/homePage/action-box.lang';
import { useTags } from '../../../hooks/useTags';
import { PlusSquareFill } from 'react-bootstrap-icons';
import RenewRequestIcon from '../../../components/icons/RenewRequestIcon';
import AddNewRequestIcon from '../../../components/icons/AddNewRequestIcon';
import CheckReqStatusIcon from '../../../components/icons/CheckReqStatusIcon';
import CheckDateIcon from '../../../components/icons/CheckDateIcon';
import DeletePermitIcon from '../../../components/icons/DeletePermitIcon';
import UpdateCarDetailsIcon from '../../../components/icons/UpdateCarDetailsIcon';
import AddFileIcon from '../../../components/icons/AddFileIcon';
import style from '../style.module.css';
import { COLORS } from '../../../data/colors';


type ActionBoxProps = {
  portalAction: ActionPortalType;
  onClick?: () => void;
};

const ActionBox = ({ portalAction, onClick = null }: ActionBoxProps) => {

  const [isHovered, setIsHovered] = React.useState(false);
  const openOtpModal = useOpenOtpModal();

  const generateTag = useTags();
  const modalTitleTag = generateTag(actionBoxLang, `${portalAction}.card-title`);

  const icon = getIcon(portalAction);
  const actionBoxStyle = getActionBoxStyle(portalAction);


  return (
    <button style={actionBoxStyle} className={`${style.actionBox}`}
      onClick={() => handleOnClick(portalAction)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className={style.actionBoxIcon}>
        {icon}
      </div>
      <div className={style.actionBoxTitle}>
        {modalTitleTag}
      </div>
    </button>
  );

  function getIcon(portalAction: ActionPortalType) {

    switch (portalAction) {
      case 'ADD_PERMIT_REQUEST':
        return (<AddNewRequestIcon width={124} height={124}
          circleColor={COLORS['indigo'][700]} iconColor='white' />
        );
      case 'ADD_FILE_TO_REQUEST':
        return <AddFileIcon width={124} height={124} circleColor={COLORS['emerald'][700]} iconColor='white' />;
      case 'CHECK_REQUEST_STATUS':
        return <CheckReqStatusIcon width={124} height={124} circleColor={COLORS['fuchsia'][700]} iconColor='white' />;
      case 'CANCEL_PERMIT':
        return <DeletePermitIcon width={124} height={124} circleColor={COLORS['purple'][700]} iconColor='white' />;
      case 'CHECK_PEMIT_VALIDITY':
        return <CheckDateIcon width={124} height={124} circleColor={COLORS['cyan'][700]} iconColor='white' />;
      case 'UPDATE_VEHICLE_DETAILS':
        return <UpdateCarDetailsIcon width={124} height={124} circleColor={COLORS['yellow'][700]} iconColor='white' />;
      case 'RENEWED_PERMIT_OPTION':
        return (
          <RenewRequestIcon width={124} height={124}
            circleColor={COLORS['lime'][700]} iconColor='white' />
        );
      default:
        return <PlusSquareFill color={COLORS['gray'][700]} />;
    }
  }

  function handleOnClick(portalAction: ActionPortalType) {

    if (onClick) {
      onClick();
      return;
    }

    openOtpModal(portalAction);
  }

  function getActionBoxStyle(portalAction: ActionPortalType): React.CSSProperties {

    const cssStyle: React.CSSProperties = {};
    let color = '';

    switch (portalAction) {
      case 'ADD_PERMIT_REQUEST':
        color = 'indigo';
        break;
      case 'ADD_FILE_TO_REQUEST':
        color = 'emerald';
        break;
      case 'CHECK_REQUEST_STATUS':
        color = 'fuchsia';
        break;
      case 'CANCEL_PERMIT':
        color = 'purple';
        break;
      case 'CHECK_PEMIT_VALIDITY':
        color = 'cyan';
        break;
      case 'UPDATE_VEHICLE_DETAILS':
        color = 'yellow';
        break;
      case 'RENEWED_PERMIT_OPTION':
        color = 'lime';
        break;
      default:
        break;
    }

    cssStyle.borderTopStyle = 'solid';
    cssStyle.borderTopWidth = isHovered ? '2px' : '12px';
    cssStyle.borderTopColor = COLORS[color][700];
    cssStyle.color = isHovered ? COLORS[color][700] : 'inherit';
    if (isHovered) {
      cssStyle.boxShadow = `0px 10px 15px -3px ${COLORS[color][700]}`;
    }

    return cssStyle;
  }

}

export default ActionBox;